import React from 'react';
import { Link } from 'react-router-dom';
import SearchBar2 from '../SearchBar/SearchBar2';
import DataTable2 from '../DataTable2/DataTable2';
import PopupWithUseClickOutside from '../Popups/PopupWithUseClickOutside';
import Popup from '../Popups/Popup';
import DataTableDisplayLengthToggle from '../DataTable2/DataTableDisplayLengthToggle';
import Pagination from '../DataTable2/Pagination';
import Cell from '../DataTable2/DataTableComponents/Cell';
import UsersInviteCard from '../UsersMgmt/UsersInviteCard';
import EditTemplateForm from '../Templates/EditTemplateForm';

export default class TemplatesIndexCard extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			sortOrder: 'asc',
			sortColumn: 'id',
			tempQuery: '',
			query: '',
			data: [],
			meta: { filters: { role: {}, accountStatus: {} } },
			apiKey: this.props.account_crud_api_key,
			get_communication_template_endpoint: this.props
				.get_communication_template_endpoint,
			isSuccessCardPopupVisible: false,
			isTimeoutCardPopupVisible: false,
			isTemplateEditCardPopupVisible: false,
			isUserInvitePopupVisible: false,
			displayOptions: [
				10,
				25,
				50,
				100
			],
			currentPage: 1,
			pageLength: 25,
			pageNeighbours: 0,
			userTemplateRequest: ''
		};

		this.onChange = this.onChange.bind(this);
		this.onSearch = this.onSearch.bind(this);
		this.onChangeSortOrder = this.onChangeSortOrder.bind(this);
		this.onChangePageLength = this.onChangePageLength.bind(this);
		this.onChangeCurrentPage = this.onChangeCurrentPage.bind(this);
		this.onShowSuccessCardPopup = this.onShowSuccessCardPopup.bind(this);
		this.onHideSuccessCardPopup = this.onHideSuccessCardPopup.bind(this);
		this.onShowTimeoutCardPopup = this.onShowTimeoutCardPopup.bind(this);
		this.onHideTimeoutCardPopup = this.onHideTimeoutCardPopup.bind(this);
		this.onShowTemplateEditCardPopup = this.onShowTemplateEditCardPopup.bind(
			this
		);
		this.onHideTemplateEditCardPopup = this.onHideTemplateEditCardPopup.bind(
			this
		);
		this.onShowUserInvitePopup = this.onShowUserInvitePopup.bind(this);
		this.onHideUserInvitePopup = this.onHideUserInvitePopup.bind(this);
	}

	render() {
		return (
			<div className="AccountsIndexCard card">
				<div className="card-body">
					<div className="row">
						<div className="col-6">
							<h1 className="card-title">
								<div className="UsersTitle">
									{I18n.t('admin.templates')}
									<span>
										{this.state.meta.page ? (
											`(${this.state.meta.page.totalElements})`
										) : (
											''
										)}
									</span>
								</div>
							</h1>
						</div>
						<div className="col-6">
							<button
								type="button"
								id="new-user"
								className="btn btn-primary"
								onClick={() => {
									this.onShowTemplateEditCardPopup('add');
								}}
							>
								{I18n.t('admin.create_template')}
							</button>
						</div>
					</div>
					<div className="row filter-section">
						<div className="col-12">
							<SearchBar2
								placeholder={I18n.t('search_bar.placeholder')}
								name="tempQuery"
								value={this.state.tempQuery}
								onChange={this.onChange}
								onSubmit={this.onSearch}
							/>
						</div>
					</div>
					<div className="row">
						<div className="col-12">
							<DataTable2
								data={this.props.data}
								sortOrder={this.state.sortOrder}
								sortColumn={this.state.sortColumn}
								columns={[
									{
										displayName: 'ID',
										apiName: 'id',
										colNum: 1,
										colWidth: 15
									},
									{
										displayName: 'Name',
										apiName: 'name',
										colNum: 2,
										colWidth: 40
									},
									{
										displayName: 'Last Updated',
										apiName: 'updated_at',
										colNum: 2,
										colWidth: 40
									},
									{
										displayName: '',
										apiName: 'edit',
										colNum: 4,
										colWidth: '',
										isSortable: false
									}
								]}
								rowRenderer={(d) => {
									return (
										<tr key={d.id} onClick={this.props.onShowUserProfilePopup}>
											<td>
												<Cell value={d.id} />
											</td>
											<td>
												<Cell value={d.template_name} />
											</td>
											<td>
												<Cell value={d.updated_at} type="date" />
											</td>
											<td>
												<Cell
													value={
														<div
															onClick={() => {
																this.onSetUrlPath(
																	d.get_communication_template_endpoint
																);
																this.onShowTemplateEditCardPopup('edit');
															}}
														>
															<i
																className="fa fa-ellipsis-h"
																aria-hidden="true"
															/>
														</div>
													}
												/>
											</td>
										</tr>
									);
								}}
								onChange={this.onChange}
								onChangeSortOrder={this.onChangeSortOrder}
							/>
						</div>
					</div>
					<div className="row table-footer">
						<div className="col-12 col-sm-6">
							<Pagination
								totalRecords={
									this.state.meta.page ? this.state.meta.page.totalElements : 0
								}
								pageLength={this.state.pageLength}
								currentPage={this.state.currentPage + 1}
								pageNeighbours={this.state.pageNeighbours}
								onChangeCurrentPage={this.onChangeCurrentPage}
							/>
						</div>
						<div className="col-12 col-sm-6">
							<DataTableDisplayLengthToggle
								totalRecords={
									this.state.meta.page ? this.state.meta.page.totalElements : 0
								}
								displayOptions={this.state.displayOptions}
								pageLength={this.state.pageLength}
								onChangePageLength={this.onChangePageLength}
							/>
						</div>
						<PopupWithUseClickOutside
							isPopupVisible={this.state.isTemplateEditCardPopupVisible}
							onHidePopup={this.onHideTemplateEditCardPopup}
							style={{ maxWidth: '750px' }}
						>
							<Popup
								title={
									this.state.userTemplateRequest === 'add' ? (
										<h1 className="card-title">
											{I18n.t('admin.create_template_title')}
										</h1>
									) : this.state.userTemplateRequest === 'Edit' ? (
										<h1 className="card-title">
											{I18n.t('admin.edit_template_title')}
										</h1>
									) : (
										'Not Support'
									)
								}
								onHidePopup={this.onHideTemplateEditCardPopup}
							>
								<EditTemplateForm
									get_communication_template_endpoint={
										this.props.get_communication_template_endpoint
									}
									userTemplateRequest={this.state.userTemplateRequest}
									thingBeingCreated={I18n.t('admin.template')}
									permissionsHelper={this.props.permissionsHelper}
									onHidePopup={this.onHideTemplateEditCardPopup}
									onShowSuccessCardPopup={this.onShowSuccessCardPopup}
									onShowTimeoutCardPopup={this.onShowTimeoutCardPopup}
								/>
							</Popup>
						</PopupWithUseClickOutside>
						<PopupWithUseClickOutside
							isPopupVisible={this.state.isSuccessCardPopupVisible}
							onHidePopup={this.onHideSuccessCardPopup}
						>
							<Popup
								title={
									<h1 className="card-title" style={{ color: 'green' }}>
										{I18n.t('success_card_title')}
									</h1>
								}
								body={I18n.t('admin.account.success_update_account')}
								onHidePopup={this.onHideSuccessCardPopup}
							/>
						</PopupWithUseClickOutside>
						<PopupWithUseClickOutside
							isPopupVisible={this.state.isTimeoutCardPopupVisible}
							onHidePopup={this.onHideTimeoutCardPopup}
						>
							<Popup
								title={
									<h1 className="card-title" style={{ color: 'red' }}>
										{I18n.t('timeout_card_title')}
									</h1>
								}
								body={I18n.t('timeout_card_body')}
								onHidePopup={this.onHideTimeoutCardPopup}
							/>
						</PopupWithUseClickOutside>
					</div>
				</div>
			</div>
		);
	}

	onChange(event) {
		const { name, value } = event.target;
		const { state } = this;
		state[name] = value;
		this.setState(state);
	}

	onSearch(event) {
		event.preventDefault();
		this.setState({ query: this.state.tempQuery });
	}

	onChangeSortOrder(sortColumn, sortOrder) {
		if (sortOrder === '' || sortOrder === 'desc') {
			this.setState({
				sortColumn: sortColumn,
				sortOrder: 'asc',
				currentPage: 0
			});
		} else if (sortOrder === 'asc') {
			this.setState({
				sortColumn: sortColumn,
				sortOrder: 'desc',
				currentPage: 0
			});
		}
	}
	onChangeCurrentPage(currentPage) {
		this.setState({ currentPage: currentPage - 1 });
	}

	onChangePageLength(pageLength) {
		this.setState({ pageLength: pageLength, currentPage: 0 });
	}

	onSetUrlPath(url_path) {
		this.setState({ get_communication_template_endpoint: url_path });
	}

	onShowSuccessCardPopup = () => {
		this.setState({ isSuccessCardPopupVisible: true });
	};

	onHideSuccessCardPopup = () => {
		this.setState({ isSuccessCardPopupVisible: false });
	};

	onShowTimeoutCardPopup = () => {
		this.setState({ isTimeoutCardPopupVisible: true });
	};

	onHideTimeoutCardPopup = () => {
		this.setState({ isTimeoutCardPopupVisible: false });
	};

	onShowTemplateEditCardPopup = (userTemplateRequest) => {
		console.log('userTemplateRequest', userTemplateRequest);
		this.setState({
			isTemplateEditCardPopupVisible: true,
			userTemplateRequest: userTemplateRequest
		});
	};

	onHideTemplateEditCardPopup = () => {
		this.setState({ isTemplateEditCardPopupVisible: false });
	};

	onShowUserInvitePopup = () => {
		this.setState({ isUserInvitePopupVisible: true });
	};

	onHideUserInvitePopup = () => {
		this.setState({ isUserInvitePopupVisible: false });
	};

	buildEndpoint() {
		return `${this.props.users_endpoint}?accountStatus=${this.state
			.accountStatus === 'ALL'
			? ''
			: this.state.accountStatus}&role=${this.state.role === 'ALL'
			? ''
			: this.state.role}&query=${this.state.query}&sort=${this.state
			.sortColumn},${this.state.sortOrder}&page=${this.state
			.currentPage}&size=${this.state.pageLength}`;
	}
}
